import { forwardRef } from 'react';

import { IconProps } from '../';

export const TimelineFidgetSpinnerIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <g filter="url(#filter0_d_4003_40707)">
        <path
          d="M9.03774 5.40283C9.31219 4.43232 10.6878 4.43231 10.9623 5.40283L12.2403 9.92228C12.2857 10.0827 12.3704 10.2292 12.4868 10.3485L15.3429 13.2763C16.0609 14.0123 15.3342 15.2225 14.3471 14.9346L10.28 13.7483C10.0972 13.695 9.90288 13.695 9.72002 13.7483L5.65289 14.9346C4.66582 15.2225 3.9391 14.0123 4.65709 13.2763L7.51327 10.3485C7.62966 10.2292 7.71438 10.0827 7.75973 9.92228L9.03774 5.40283Z"
          fill="#C8D548"
        />
        <path
          d="M8.0752 5.13086C8.62408 3.18983 11.3759 3.18982 11.9248 5.13086L13.2021 9.65039L16.0586 12.5781C17.4945 14.0501 16.0414 16.4701 14.0674 15.8945L10 14.708L5.93262 15.8945C3.95859 16.4701 2.5055 14.0501 3.94141 12.5781L6.79785 9.65039L8.0752 5.13086Z"
          fill="none"
          stroke="white"
          strokeWidth="2"
        />
      </g>
      <defs>
        <filter id="filter0_d_4003_40707" x="0.357513" y="1.6748" width="19.285" height="18.3101" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4003_40707" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4003_40707" result="shape" />
        </filter>
      </defs>
    </svg>
  );
});

export default TimelineFidgetSpinnerIcon;
